import {Component, forwardRef, Input} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";

@Component({
  selector: 'custom-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true
    }
  ]
})
export class CheckboxComponent implements ControlValueAccessor {

  @Input() checked = false;

  @Input() isDisabled?: boolean | null = false;

  @Input() labelPosition?: 'left' | 'right' | null = null;

  private onChange = (_:any) => { /*void*/ };

  private onTouched = () => {/*void*/};

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  writeValue(checked: boolean): void {
    this.checked = checked;
  }

  onInput() {
    this.checked = !this.checked;
    this.onTouched();
    this.onChange(this.checked);
  }

}
